export default __webpack_public_path__ + "static/media/restart.da9e41cf.svg";